import { createApiClient } from '@london-life/api-client';
import { createCsrfStore } from '@london-life/auth-client';
import { env } from './env';

// one API client and one CSRF store for the whole player app
export const csrf = createCsrfStore('ll_csrf');
export const api = createApiClient({ baseUrl: env.apiOrigin, getCsrfToken: csrf.get });
